// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-detail {
  padding: var(--space-4);
  max-width: 600px;
  margin: 0 auto;
}

.game-detail__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-4);
}

.game-detail__back {
  background: none;
  border: none;
  font-family: var(--font-heading);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--color-fire-400);
  cursor: pointer;
  padding: 0;
  transition: color var(--transition-fast);
}

.game-detail__back:hover {
  color: var(--color-fire-500);
}

.game-detail__actions {
  display: flex;
  gap: var(--space-3);
  margin-top: var(--space-4);
}

.game-detail__actions .tavern-btn-secondary {
  flex: 1;
}

.game-detail__actions .tavern-btn-danger {
  flex: 1;
  width: auto;
  height: auto;
}

@media (max-width: 425px) {
  .game-detail {
    padding: var(--space-3);
  }

  .game-detail__actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Games/GameDetailPage.css"],"names":[],"mappings":"AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n.game-detail {\n  padding: var(--space-4);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.game-detail__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-4);\n}\n\n.game-detail__back {\n  background: none;\n  border: none;\n  font-family: var(--font-heading);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-fire-400);\n  cursor: pointer;\n  padding: 0;\n  transition: color var(--transition-fast);\n}\n\n.game-detail__back:hover {\n  color: var(--color-fire-500);\n}\n\n.game-detail__actions {\n  display: flex;\n  gap: var(--space-3);\n  margin-top: var(--space-4);\n}\n\n.game-detail__actions .tavern-btn-secondary {\n  flex: 1;\n}\n\n.game-detail__actions .tavern-btn-danger {\n  flex: 1;\n  width: auto;\n  height: auto;\n}\n\n@media (max-width: 425px) {\n  .game-detail {\n    padding: var(--space-3);\n  }\n\n  .game-detail__actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
